@if (thread) {
    <div class="file-container d-flex flex-column">
    <div class="view">
        <div class="conversation-actions">
            <button (click)="openInChatbot()" color="primary" mat-stroked-button>
                <mat-icon>smart_toy</mat-icon>
                Åpne i chatbot
            </button>
        </div>
        <!-- Tabs -->
        <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedIndex">
            <mat-tab [disabled]="true">
                <ng-template mat-tab-label>
                    <div class="tab-header-label">
                        <span class="category"><small>Conversation</small></span>
                        <span class="object-name">{{ conversationTitle }}</span>
                    </div>
                </ng-template>
                <!-- No content required -->
            </mat-tab>
            <mat-tab label="Details">
                <div class="tab-content">
                    <p><strong>Email:</strong> {{ thread.email }}</p>
                    <p><strong>HubSpot ID:</strong> {{ thread.hubSpotId }}</p>
                    <p><strong>Chatbot:</strong> {{ chatbot?.name || 'Unavailable' }}
                        @if (chatbot; as chatbotDetails) {
                            <mat-icon [routerLink]="['/chatbots', chatbotDetails.id]" style="cursor: pointer; font-size: 16px;"
                                      target="_blank">open_in_new
                            </mat-icon>
                        }
                    </p>
                    <p><strong>Created:</strong> {{ thread.created | date:'full' }}</p>
                    <p><strong>Last Modified:</strong> {{ thread.lastModified | date:'full' }}</p>
                    <p><strong>Thread:</strong> {{ thread.thread }}</p>
                    <p><strong>Approved:</strong> {{ thread.approved ? 'Yes' : 'No' }}</p>
                    <p><strong>Dismissed:</strong> {{ thread.dismissed ? 'Yes' : 'No' }}</p>
                    <p><strong>Thumb Up:</strong> {{ thread.thumbUp ? 'Yes' : 'No' }}</p>
                    <p><strong>Thumb Down:</strong> {{ thread.thumbDown ? 'Yes' : 'No' }}</p>
                </div>
            </mat-tab>
            <mat-tab label="Messages">
                <div class="tab-content">
                    @for (message of thread.messages; track message) {
                        <div>
                            @if (!message.user && message.functionsCalled?.length) {
                                <div class="function-call-log">
                                    <p class="function-call-title">Functions called:</p>
                                    <ul>
                                        @for (fn of message.functionsCalled; track fn) {
                                            <li>
                                                <span class="fn-name">{{ fn.name }}</span>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            }
                            <div class="conversation-message">
                                <strong>{{ message.user ? 'User' : 'Assistant' }}:</strong>
                                @if (message.assistantId) {
                                    <span class="assistant-routing"
                                          [matTooltip]="getAssistantSelectionTooltip(message)"
                                          matTooltipPosition="above">
                                        <mat-icon>smart_toy</mat-icon>
                                        {{ getAssistantDisplayName(message.assistantId) }}
                                    </span>
                                }
                                <app-conversation-transcript-renderer
                                        [conversationId]="thread?.id || ''"
                                        [chatbot]="chatbot"
                                        [message]="message">
                                </app-conversation-transcript-renderer>
                            </div>
                            @if (message.user) {
                                <div>
                                    <p><strong>Page Title:</strong> {{ message.pageTitle }}</p>
                                    <p><strong>Page URL:</strong> <a href="{{message.pageUrl}}"
                                                                     target="_blank">{{ message.pageUrl }}</a></p>
                                    <p>
                                        <strong>Referrer:</strong> {{ message.referrer ? (message.referrer.indexOf("?") > -1 ? message.referrer.split("?")[0] : message.referrer) : "" }}
                                    </p>
                                    <p><strong>Meta Description:</strong> {{ message.metaDescription }}</p>
                                    <p><strong>Meta Keywords:</strong> {{ message.metaKeywords }}</p>
                                </div>
                            }
                            <hr>
                        </div>
                    }
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    </div>
}
